import { SpeechConfig } from 'microsoft-cognitiveservices-speech-sdk';

const speechSubscriptionKey = '106c5401b06d4cf0bffb612766b638d4';
const speechRegion = 'westeurope';

export const createSpeechConfig = () => SpeechConfig.fromSubscription(speechSubscriptionKey, speechRegion);
